import Popover from '@mui/material/Popover';
import React from 'react';
import { ix } from '../../../../utils/ix';
import { ColorInput, ColorPicker } from '../../../atoms';
export function ColorField(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handlePickerOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePickerClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    return (React.createElement("div", { className: props.className, id: props.id },
        React.createElement("div", { onClick: handlePickerOpen },
            React.createElement(ColorInput, { id: ix(props.id, 'input'), value: props.value, readonly: true })),
        React.createElement(Popover, { open: open, anchorEl: anchorEl, onClose: handlePickerClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            } },
            React.createElement(ColorPicker, { id: ix(props.id, 'picker'), value: props.value, onChange: props.onChange }))));
}
//# sourceMappingURL=ColorField.js.map